export default {
  install(Vue, { store }) {
    const permissionList = [
      {
        type: "診所設定",
        name: "查看診所設定",
        permission: "GENERAL_SETTINGS_READ",
        required: [],
      },
      {
        type: "診所設定",
        name: "修改診所設定",
        permission: "GENERAL_SETTINGS_WRITE",
        required: ["GENERAL_SETTINGS_READ"],
      },
      {
        type: "診所設定",
        name: "查看帳號",
        permission: "ACCOUNT_READ",
        required: [],
      },
      {
        type: "診所設定",
        name: "修改帳號",
        permission: "ACCOUNT_WRITE",
        required: ["ACCOUNT_READ"],
      },
      {
        type: "診所設定",
        name: "刪除帳號",
        permission: "ACCOUNT_DELETE",
        required: ["ACCOUNT_READ", "ACCOUNT_WRITE"],
      },
      {
        type: "診所設定",
        name: "管理角色權限",
        permission: "ROLE",
        required: ["ACCOUNT_READ", "ACCOUNT_WRITE"],
      },
      {
        type: "診所設定",
        name: "查看營業時間",
        permission: "BIZ_HOURS_READ",
        required: [],
      },
      {
        type: "診所設定",
        name: "修改營業時間",
        permission: "BIZ_HOURS_WRITE",
        required: ["BIZ_HOURS_READ"],
      },
      {
        type: "診所設定",
        name: "查看醫師排班",
        permission: "DOCTOR_ROASTER_READ",
        required: [],
      },
      {
        type: "診所設定",
        name: "修改醫師排班",
        permission: "DOCTOR_ROASTER_WRITE",
        required: ["DOCTOR_ROASTER_READ"],
      },
      {
        type: "診所設定",
        name: "自訂表單功能",
        permission: "CUSTOMIZE_FORM",
        required: [],
      },
      {
        type: "診所設定",
        name: "管理系統功能",
        permission: "NXVET_SYSTEM",
        required: [],
      },
      {
        type: "診所設定",
        name: "管理NxVet方案",
        permission: "NXVET_PLANS",
        required: [],
      },
      {
        type: "診所設定",
        name: "管理同步工具",
        permission: "NXVET_SYNCTOOL",
        required: [],
      },
      {
        type: "診所設定",
        name: "管理Line@醫病關係管理平台",
        permission: "NXVET_SCRM_ADMIN",
        required: [],
      },
      {
        type: "診所設定",
        name: "查看採購專區",
        permission: "SHOP_READ",
        required: [],
      },
      {
        type: "今日看診",
        name: "查看今日病歷及預約掛號狀態",
        permission: "DAILY_STATUS",
        required: [],
      },
      {
        type: "今日看診",
        name: "執行掛號工作",
        permission: "CHECK_IN",
        required: ["DAILY_STATUS"],
      },
      {
        type: "今日看診",
        name: "查看藥單及待辦工作",
        permission: "DRUG_TASK_READ",
        required: [],
      },
      {
        type: "今日看診",
        name: "執行藥單及待辦工作",
        permission: "DRUG_TASK_WRITE",
        required: ["DRUG_TASK_READ"],
      },
      {
        type: "今日看診",
        name: "查看檢測及待辦工作",
        permission: "LAB_TASK_READ",
        required: [],
      },
      {
        type: "今日看診",
        name: "執行檢測及待辦工作",
        permission: "LAB_TASK_WRITE",
        required: ["LAB_TASK_READ"],
      },
      {
        type: "病歷",
        name: "查看寵物資料",
        permission: "PET_READ",
        required: [],
      },
      {
        type: "病歷",
        name: "修改寵物資料",
        permission: "PET_WRITE",
        required: ["PET_READ"],
      },
      {
        type: "病歷",
        name: "刪除寵物資料",
        permission: "PET_DELETE",
        required: ["PET_WRITE", "PET_READ", "RECORD_DELETE"],
      },
      {
        type: "病歷",
        name: "查看病歷紀錄與住院紀錄",
        permission: "RECORD_READ",
        required: [],
      },
      {
        type: "病歷",
        name: "開立慢性病領藥單",
        permission: "CHRONIC_DRUG_WRITE",
        required: ["RECORD_READ"],
      },
      {
        type: "病歷",
        name: "修改病歷紀錄與住院紀錄",
        permission: "RECORD_WRITE",
        required: ["RECORD_READ"],
      },
      {
        type: "病歷",
        name: "刪除病歷紀錄與住院紀錄",
        permission: "RECORD_DELETE",
        required: ["RECORD_WRITE", "RECORD_READ"],
      },
      {
        type: "病歷",
        name: "業績分配（可以調整病歷內「業績分配」欄位）",
        permission: "RECORD_BELONGS",
        required: ["RECORD_WRITE", "RECORD_READ"],
      },
      {
        type: "病歷",
        name: "修改業績分配比例",
        permission: "RECORD_BELONGS_DISTRIBUTION",
        required: ["RECORD_WRITE", "RECORD_READ"],
      },
      {
        type: "病歷",
        name: "取消病歷鎖帳",
        permission: "RECORD_BILL_UNLOCK",
        required: ["RECORD_WRITE", "RECORD_READ"],
      },
      {
        type: "病歷",
        name: "看診醫師(可接受預約, 掛號, 及排班)",
        permission: "DOCTOR",
        required: ["RECORD_WRITE", "RECORD_READ"],
      },
      {
        type: "病歷",
        name: "執行住院計劃",
        permission: "EXECUTE_IN_HOSPITAL_PLAN",
        required: ["RECORD_READ"],
      },
      {
        type: "飼主",
        name: "查看飼主資料",
        permission: "CUSTOMER_READ",
        required: [],
      },
      {
        type: "飼主",
        name: "修改飼主資料",
        permission: "CUSTOMER_WRITE",
        required: ["CUSTOMER_READ"],
      },
      {
        type: "飼主",
        name: "刪除飼主資料",
        permission: "CUSTOMER_DELETE",
        required: ["CUSTOMER_READ", "CUSTOMER_WRITE", "PET_DELETE"],
      },
      {
        type: "飼主",
        name: "下載飼主資料",
        permission: "CUSTOMER_EXPORT",
        required: ["CUSTOMER_READ"],
      },
      {
        type: "預約",
        name: "查看預約紀錄",
        permission: "BOOKING_READ",
        required: [],
      },
      {
        type: "預約",
        name: "修改預約紀錄",
        permission: "BOOKING_WRITE",
        required: ["BOOKING_READ"],
      },
      {
        type: "收銀台",
        name: "查看帳單及收款工作",
        permission: "BILLING_READ",
        required: [],
      },
      {
        type: "收銀台",
        name: "執行帳單及收款工作",
        permission: "BILLING_WRITE",
        required: ["BILLING_READ"],
      },
      {
        type: "收銀台",
        name: "搜尋歷史帳單",
        permission: "BILLING_SEARCH",
        required: ["BILLING_READ"],
      },
      {
        type: "收銀台",
        name: "查看結算統計",
        permission: "BILLING_READ_STAT",
        required: ["BILLING_READ"],
      },
      {
        type: "收銀台",
        name: "統計帳單和匯出報表",
        permission: "BILLING_STAT",
        required: ["BILLING_READ_STAT"],
      },
      {
        type: "收銀台",
        name: "查看與執行其他收支",
        permission: "BILLING_OTHERS",
        required: [],
      },
      {
        type: "收銀台",
        name: "查看與執行收銀台交班",
        permission: "BILLING_HANDOVER",
        required: [],
      },
      {
        type: "收銀台",
        name: "執行呆帳標記功能",
        permission: "BILLING_BADDEBT",
        required: [],
      },
      {
        type: "收銀台",
        name: "執行呆帳收款",
        permission: "BILLING_BADDEBT_CHECKOUT",
        required: [],
      },
      {
        type: "收銀台",
        name: "查看與執行業績分配",
        permission: "BILLING_DISTRIBUTION_READ",
        required: [],
      },
      {
        type: "進銷存",
        name: "查看品項&耗材組合",
        permission: "PRODUCT_READ",
        required: [],
      },
      {
        type: "進銷存",
        name: "修改品項&耗材組合",
        permission: "PRODUCT_WRITE",
        required: ["PRODUCT_READ"],
      },
      {
        type: "進銷存",
        name: "查看供應商",
        permission: "SUPPLIER_READ",
        required: [],
      },
      {
        type: "進銷存",
        name: "修改供應商",
        permission: "SUPPLIER_WRITE",
        required: ["SUPPLIER_READ"],
      },
      {
        type: "進銷存",
        name: "查看進貨單",
        permission: "PURCHASE_FORM_READ",
        required: [],
      },
      {
        type: "進銷存",
        name: "查看應付帳款",
        permission: "PAYMENT_FORM_READ",
        required: [],
      },
      {
        type: "進銷存",
        name: "修改應付帳款",
        permission: "PAYMENT_FORM_WRITE",
        required: ["PAYMENT_FORM_READ"],
      },
      {
        type: "進銷存",
        name: "修改進貨單",
        permission: "PURCHASE_FORM_WRITE",
        required: ["PURCHASE_FORM_READ"],
      },
      {
        type: "進銷存",
        name: "查看採購單",
        permission: "ORDER_FORM_READ",
        required: [],
      },
      {
        type: "進銷存",
        name: "修改採購單",
        permission: "ORDER_FORM_WRITE",
        required: ["ORDER_FORM_READ"],
      },
      {
        type: "進銷存",
        name: "查看銷貨單",
        permission: "SALE_FORM_READ",
        required: [],
      },
      {
        type: "進銷存",
        name: "修改銷貨單",
        permission: "SALE_FORM_WRITE",
        required: ["SALE_FORM_READ"],
      },
      {
        type: "進銷存",
        name: "查看庫存盤點單",
        permission: "STOCK_CHECK_FORM_READ",
        required: [],
      },
      {
        type: "進銷存",
        name: "修改庫存盤點單",
        permission: "STOCK_CHECK_FORM_WRITE",
        required: ["STOCK_CHECK_FORM_READ"],
      },
      {
        type: "進銷存",
        name: "查看服務",
        permission: "SERVICE_READ",
        required: [],
      },
      {
        type: "進銷存",
        name: "修改服務",
        permission: "SERVICE_WRITE",
        required: ["SERVICE_READ"],
      },
      {
        type: "進銷存",
        name: "查看其他設定",
        permission: "ERP_SETTINGS_READ",
        required: [],
      },
      {
        type: "進銷存",
        name: "修改其他設定",
        permission: "ERP_SETTINGS_WRITE",
        required: ["ERP_SETTINGS_READ"],
      },
      {
        type: "進銷存",
        name: "查看統計報表",
        permission: "ERP_REPORTS",
        required: [],
      },
    ];

    Vue.prototype.$permission = {
      groupByPage: (append = {}) => {
        let group = {};
        permissionList.forEach((data) => {
          if (!group[data.type]) {
            group[data.type] = [];
          }
          group[data.type].push(Object.assign({}, data, append));
        });
        return group;
      },
      list: () => {
        return permissionList;
      },
      grant: (permission) => {
        let optRoleID = store.state.user.user.optRoleID;
        let optPermissions = store.state.user.user.optPermissions;
        // let roles = store.state.change.roles;
        // console.log("permission:" + permission);
        // console.log("userPermissionDetail:" + userPermissionDetail);
        // console.log("roles:" + JSON.stringify(roles));
        if (optRoleID === "admin") {
          return true;
        } else {
          // let role = roles.find((role) => role._id === userPermissionDetail);
          // let rolePermissions = role ? role.permissions : [];
          return optPermissions.indexOf(permission) > -1;
        }
      },
      customized: (type) => {
        let setting = store.state.change.setting;
        return setting[type] ? true : false;
      },
      booking: (type) => {
        let setting = store.state.change.setting;
        if (!setting.bookingSetting) return false;
        return setting.bookingSetting[type] ? true : false;
      },
      alliance: () => {
        return store.state.user.user.alliance ? true : false;
      },
    };
  },
};
